import { Link } from 'react-router-dom'
import Styles from '../../styles/Home.module.css'
import Stack from '@mui/material/Stack';
import { useMediaQuery } from 'react-responsive';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../../images/big_logo.webp'

export default function Menu(props) {

    const bigScreen = useMediaQuery({
        query: '(min-width: 600px)'
    })

    const [showMenu, setShowMenu] = useState(false)

    return (
        <>
            <Dialog
                fullWidth={true}
                open={showMenu}
                onClose={() => setShowMenu(false)}
            >
                <Stack justifyContent='center' alignItems='center' className={Styles.menuDialog}>
                    <IconButton onClick={() => setShowMenu(false)} size='large' sx={{ alignSelf: 'flex-end' }}>
                        <CloseIcon fontSize='large' />
                    </IconButton>

                    <Link className={Styles.menuDialogItem} to={`/plans`}>Planes</Link>
                    <Link className={Styles.menuDialogItem} to={`/faq`}>Preguntas frecuentes</Link>
                    <Link className={Styles.menuDialogItem} to={`/admin/login`}>Ingresar</Link>
                    <Link className={Styles.menuDialogItem} to={`/admin/signup`}>Crear cuenta</Link>
                </Stack>
            </Dialog>

            <nav className={Styles.menu}>
                {bigScreen ? <div>
                    <Link className={Styles.menuItem} to={`/`}><img src={logo} className={Styles.menuLogo} /></Link>
                    <Link className={Styles.menuItem} to={`/plans`}>Planes</Link>
                    <Link className={Styles.menuItem} to={`/faq`}>Preguntas frecuentes</Link>
                    <Link className={Styles.menuItem} to={`/admin/login`}>Ingresar</Link>
                    <Link className={Styles.menuPriorityItem} to={`/admin/signup`}>Crear cuenta</Link>
                </div> : <div>
                    <Link to={`/`}><img src={logo} className={Styles.menuLogo} /></Link>

                    <IconButton size='large' color='text.primary' onClick={() => setShowMenu(!showMenu)}>
                        <MenuIcon fontSize='large' sx={{ color: 'white' }} />
                    </IconButton>
                </div>
                }
            </nav>
        </>
    )
}